export default __webpack_public_path__ + "static/gamer-1e343e6b6baa29eeeec1fd035329928d.png";